<template>
    <div class="d-flex align-items-center justify-content-center">
        <template>
            <ul class="list-group w-100">
                <li class="list-group-item py-25 px-50" v-for="(error,i) in row.NetsisEksikVeriErrors" :key="i">
                    <span class="text-nowrap text-secondary font-weight-bolder">  {{ error }} </span>
                </li>
                <li class="list-group-item py-25 px-50" v-if="(row.NetsisEksikVeriErrors || []).length == 0 && row.IsNetsisIntegrated">
                    <span class="text-nowrap text-success font-weight-bolder">Netsis kaydı başarılı.</span>
                </li>
                <li class="list-group-item py-25 px-50" v-if="(row.NetsisEksikVeriErrors || []).length == 0 && !row.IsNetsisIntegrated">
                    <span class="text-nowrap text-danger font-weight-bolder">Netsis kaydı yok.</span>
                </li>
            </ul>
        </template>
    </div>
</template>

<script>
export default {
    props:{
        row:Object,
        field:Object
    },
}
</script>

<style>

</style>